import { Link } from 'react-router-dom'
import { BasicLayout } from '../../modules/Layouts/basicLayout'
import TableDetalleCompras from './Components/LibroComprasDetalle/TableDetalleCompras'

const LibroComprasDetalle = () => {
  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to={'/mas-opciones/libro-compras'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Detalle de Libro de IVA para Compras</h3>
      </div>
      <div className='separador'></div>
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card' style={{height: 'auto'}}>
            <div className='w-layout-vflex card-content'>
              <TableDetalleCompras />
            </div>
          </div>
        </div>
      </div>
    </BasicLayout>
  )
}

export default LibroComprasDetalle
